// The API includes historical municipalities. Unknown/ambiguous places must
// never silently become a different municipality when calculating a tax code.
function findBelfiore(catalog, value) {
    const needle = String(value || '').trim().toLocaleUpperCase('it-IT');
    if (!needle) return null;
    const entries = Object.entries(catalog || {});
    if (/^[A-Z][0-9]{3}$/.test(needle)) {
        return entries.some(([, code]) => code === needle) ? needle : null;
    }
    const codes = [...new Set(entries
        .filter(([name]) => name.trim().toLocaleUpperCase('it-IT') === needle)
        .map(([, code]) => code))];
    return codes.length === 1 ? codes[0] : null;
}

module.exports = { findBelfiore };
